import script from "./ImportWizard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportWizard.vue?vue&type=script&setup=true&lang=ts"

import "./ImportWizard.vue?vue&type=style&index=0&id=0b4ac80e&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b4ac80e"]])

export default __exports__